
import { WechatMenu } from "@/script/apps/wechat/entity/WechatEntity";
import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { WechatMenuService } from "@/script/apps/wechat/service/WechatMenuService";

@Options({})
export default class WechatMenuList extends BaseList {
  private queryEntity: WechatMenu = {};

  private dataList: WechatMenu[] = [];

  private service = new WechatMenuService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_wechat_menu",
      "/wechat/menu",
      "/wechat/menu",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const currDataList: WechatMenu[] = data.list as WechatMenu[];
    currDataList.forEach((item) => {
      item.uploadName = item.upload! === true ? "是" : "否";
    });
    this.dataList = currDataList;
  }

  createMenu() {
    this.service.createMenu(
      (data: any) => {
        ElMessage.success("发布成功!");
        this.loadList();
      },
      function (error: Error) {
        ElMessage.error("发布失败，失败原因：" + error.message);
      }
    );
  }
}
